<template>
  <div class="mxDownload">
    <!-- ios -->
    <div class="ios downloadItem">
      <div class="qrcodeItem">
        <!-- 默认展示 -->
        <div class="default itemContent">
          <img class="defaultImg" src="../assets/downloadImg/ios-download.png" alt="">
        </div>
        <!-- hover展示 -->
        <div class="hoverItem itemContent">
          <div class="hoverContent">
            <!-- 头部切换二维码文案 -->
            <div class="changeIOSqrcode" @click="changeIphoneCode">
              <img class="changeIcon" src="../assets/downloadImg/vpnchange.png" alt="">
              <div class="changetext" v-if="isAliens">{{ $t('vpn.pcCoreZH') }}</div>
              <div class="changetext" v-else>{{ $t('vpn.pcCoreAliens') }}</div>
            </div>
            <!-- 二维码图片 -->
            <img class="iphone-code" @click="enlargeImg('ios')" v-if="isAliens" src="../assets/downloadImg/iphone-aliens.png" alt="">
            <img class="iphone-code" @click="enlargeImg('ios')" v-else src="../assets/downloadImg/iphone-zh.png" alt="">
            <img class="mxScanIcon iosScanIcon" @click="enlargeImg('ios')" src="../assets/downloadImg/vpnlogo.png" alt="">
            <!-- 下载提示 -->
            {{ isAliens ? $t('vpn.downloadAliens') : $t('vpn.downloadZH') }}
          </div>
        </div>
        <!-- 放大展示 -->
        <largeCodeBox class="qrcodeItem-large" v-show="showIOSVpnLarge">
          <div slot="codeSlot">
            <img class="iphone-code" @click="enlargeImg('ios')" v-if="isAliens" src="../assets/downloadImg/iphone-aliens.png" alt="">
            <img class="iphone-code" @click="enlargeImg('ios')" v-else src="../assets/downloadImg/iphone-zh.png" alt="">
            <img class="mxScanIcon" @click="enlargeImg('ios')" src="../assets/downloadImg/vpnlogo.png" alt="">
          </div>
        </largeCodeBox>
      </div>
      <div class="item_title">{{ $t('mx.ios') }}</div>
      <div class="item_configure" @click="toDownloadGuidance('ios')">{{ $t('vpn.configureSeq') }}</div>
    </div>
    <!-- android -->
    <div class="android downloadItem">
      <div class="qrcodeItem" @click="enlargeImg('android')">
        <div class="default itemContent">
          <img class="defaultImg" src="../assets/downloadImg/android-download.png" alt="">
        </div>
        <div class="hoverItem itemContent">
          <div class="hoverContent">
            <canvas ref="androidCode"></canvas>
            <img class="mxScanIcon" src="../assets/downloadImg/vpnlogo.png" alt="">
            {{ $t('mx.downloadScan') }}
          </div>
        </div>
        <largeCodeBox class="qrcodeItem-large" v-show="showAndroidVpnLarge">
          <div slot="codeSlot">
            <canvas ref="androidVpnLargeCode"></canvas>
            <img class="mxScanIcon" src="../assets/downloadImg/vpnlogo.png" alt="">
          </div>
        </largeCodeBox>
      </div>
      <div class="item_title">{{ $t('mx.android') }}</div>
      <div class="item_configure" @click="toDownloadGuidance('android')">{{ $t('vpn.configureSeq') }}</div>

    </div>
    <!-- mac -->
    <div class="mac downloadItem">
      <div class="qrcodeItem" @click="toDownloadFile('VPN_mac_Link')">
        <div class="default itemContent">
          <img class="defaultImg" src="../assets/downloadImg/mac-download.png" alt="">
        </div>
        <div class="hoverItem itemContent">
          <div class="hoverContent">
            <img class="downIcon" src="../assets/downloadImg/small-download.png" alt="">
            {{ $t('mx.downloadClick') }}
          </div>
        </div>
      </div>
      <div class="item_title">{{ $t('mx.mac') }}</div>
      <div class="item_configure" @click="toDownloadGuidance('mac')">{{ $t('vpn.configureSeq') }}</div>
      <div class="item_configure" @click="toDownloadFile('VPN_mac_Configure')">{{ $t('vpn.configureDownload') }}</div>

    </div>
    <!-- window -->
    <div id="targetDom" class="window downloadItem">
      <div class="qrcodeItem" @click="toDownloadFile('VPN_windows_Link')">
        <div class="default itemContent">
          <img class="defaultImg" src="../assets/downloadImg/pc-download.png" alt="">
        </div>
        <div class="hoverItem itemContent">
          <div class="hoverContent">
            <img class="downIcon" src="../assets/downloadImg/small-download.png" alt="">
            {{ $t('mx.downloadClick') }}
          </div>
        </div>
      </div>
      <div class="item_title">{{ $t('mx.window') }}</div>
      <div class="item_configure" @click="toDownloadGuidance('windows')">{{ $t('vpn.configureSeq') }}</div>
      <div class="item_configure" @click="toDownloadFile('VPN_windows_Configure')">{{ $t('vpn.configureDownload') }}</div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode';
import { is4aLogin } from '@/mx-service/libs/utils';
import { getApiConfig } from '@/mx-service/libs/http/config'
import largeCodeBox from "@/components/largeCodeBox";
import {getLang} from '../mx-service/libs/locale'

export default {
  components: {
    largeCodeBox
  },
  props: {
    closeAllLargeBox: Function
  },
  data(){
    return{
      showMacDialog: false,
      isAliens: false,  // 是否海外
      androidqrCodeData: getApiConfig().defaultMobileUrl,
      qrCodeOptions: {
        width: 80,
        height: 80
      },
      qrLargeCodeOptions: {
        width: 140,
        height: 140
      },
      vpnList: [],
      showIOSVpnLarge: false,
      showAndroidVpnLarge: false
    }
  },
  methods: {
    // 切换iphone海外\内地静态二维码
    changeIphoneCode(){
      this.isAliens = !this.isAliens
    },
    // 下载安装指引
    toDownloadGuidance(e){
      const lang = localStorage.getItem('locale')
      const params = lang === 'zh-CN' ? `VPN_${e}_Guidance`: `VPN_${e}_Guidance_en`
      this.toDownloadFile(params)
    },
    // 下载文件
    async toDownloadFile(e){
      const status = await is4aLogin(e, true)
      let getListStatus = true
      if(!status) return
      // 请求列表初始化失败情况
      if(!this.vpnList || this.vpnList.length === 0) {
        // 重新获取列表数据
        getListStatus = await this.getData()
      }
      if(!getListStatus) return
      const data = this.vpnList.filter(item => item.paramId === e)[0]
      console.log('下载内容', data, this.vpnList)
      window.location.href = data.paramValue;
    },

    // 监听是否处于等待下载状态
    async isDownloading(){
      const downloadParamId = this.$route.query.id
      if(await is4aLogin() && downloadParamId && downloadParamId.toLowerCase().includes('vpn')){
        this.toDownloadFile(downloadParamId)
      }
    },
    // 放大二维码
    enlargeImg(type){
      if(type === 'ios') {
        this.showIOSVpnLarge = !this.showIOSVpnLarge
        this.showAndroidVpnLarge = false
      }
      else {
        this.showAndroidVpnLarge = !this.showAndroidVpnLarge
        this.showIOSVpnLarge = false
      }
      this.closeAllLargeBox()
    },
    // 缩小全部二维码
    smallImg(){
      this.showAndroidVpnLarge = false
      this.showIOSVpnLarge = false
    },
    // 加载列表数据
    async getData(){
      let getListStatus = true
      try {
        const data = await mx.request("getVPNUrl");
        this.vpnList = data
        if(!data) throw new Error('空数据')
        this.androidqrCodeData = this.vpnList.filter(item => item.paramId === "VPN_android_Link")[0].paramValue
      } catch (error) {
        getListStatus = false
        this.$MdMessage({
            message: this.$t('netError'),
            type: 'warning',
        });
      }
      return getListStatus
    }
  },
  async mounted(){
    // 判断单点登录状态
    // const status = true
    const status = await is4aLogin()
    let getListStatus = true
    if(status) {
      getListStatus = await this.getData()
    }
    QRCode.toCanvas(this.$refs.androidCode, this.androidqrCodeData, this.qrCodeOptions, function (error) {
      if (error) console.error(error);
    });
    QRCode.toCanvas(this.$refs.androidVpnLargeCode, this.androidqrCodeData, this.qrLargeCodeOptions, function (error) {
      if (error) console.error(error);
    });
    // 判断是否有下载进程
    if(getListStatus) await this.isDownloading()
  }
}
</script>
<style lang="less" scoped>
.mxDownload {
  width: 100%;
  // padding: 0 69px 0 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  .downloadItem {
    flex-shrink: 0;
    flex: 0 0 auto;
    width: 110px;
    // height: 120px;
    border-radius: 12px;
    margin: 0 8px;
    height: 240px;
    
    .itemContent {
      background-color: #ffffff;
      border-radius: 12px;
    }

    .qrcodeItem {
      position: relative;
      cursor: pointer;
      .default, .hoverItem {
        width: 110px;
        height: 110px;
        .defaultImg {
          // margin-top: -14.2857px;
          // margin-left: -14.2857px;
          // width: 148.57px;
          // height: 148.57px;
          // border-radius: 9px;
          width: 110px;
          height: 110px;
          border-radius: 12px;
        }
      }
      .hoverItem {
        display: none;
      }
      &:hover .default {
        display: none;
      }
      &:hover .hoverItem {
        display: block;
        // padding: 9.615%;
        box-sizing: border-box;
      }
      .hoverContent {
        position: relative;
        z-index: 49;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 10px;
        color: #333333;
        line-height: 13px;
        background: #FFFFFF;
        box-shadow: 0px 1.6px 14.4px 0px rgba(0, 0, 0, 0.05);
        border-radius: 12px;
        .mxScanIcon {
          width: 18px;
          height: 18px;
          position: absolute;
          // left: calc(50% - 9px);
          top: calc(50% - 14px);
          background: #fff;
          z-index: 50;
        }
        .iphone-code {
          width: 72px;
          height: 72px;
        }
        .iosScanIcon {
          top: calc(50% - 12px);
        }
        .downIcon {
          width: 36px;
          height: 36px;
          margin-bottom: 10px;
        }
        .changeIOSqrcode {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 9px;
          color: #2496FF;
          line-height: 13px;
          text-wrap: nowrap;
          width: 100%;
          flex-wrap: wrap;
          .changetext {
            width: calc(100% - 38px);
            white-space: normal;
          }

          .changeIcon {
            width: 10px;
            height: 10px;
            margin-right: 3px;
          }
        }
      }
      .qrcodeItem-large {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        box-shadow: 0px 2px 18px 0px rgba(0,0,0,0.11);
        position: absolute;
        z-index: 80;
        // top: -10px;
        // left: -10px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 12px;
        .iphone-code {
          width: 140px;
          height: 140px;
          border-radius: 12px;
        }
        canvas{
          border-radius: 12px;
        }
        .mxScanIcon {
          position: absolute;
          z-index: 99;
          width: 30px;
          height: 30px;
          top: calc(50% - 15px);
          left: calc(50% - 15px);
        }
      }
    }
    .item_title {
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: rgba(0,0,0,0.85);
      line-height: 18px;
      margin: 16px 0 12px;
      font-size: 14px;
      white-space: pre-wrap;
    }
    .item_configure {
      font-size: 14px;
      color: #2496FF;
      line-height: 18px;
      margin-bottom: 6px;
      cursor: pointer;
    }
  }
}


</style>